import $ from 'jquery';

window.theme.apiPromise = window.theme.apiPromise || null;
var apiPromise = window.theme.apiPromise;

/* global google */

export function loadAPI(key) {
  if (apiPromise === null) {
    apiPromise = getScriptWithPromise('https://maps.googleapis.com/maps/api/js?key=' + key);
  }
  return apiPromise;
}

export function createMap(container, options) {
  var map = new google.maps.Map(container, options);
  var center = map.getCenter();

  // eslint-disable-next-line no-unused-vars
  var marker = new google.maps.Marker({
    map: map,
    position: center,
  });

  google.maps.event.addDomListener(window, 'resize', function() {
    google.maps.event.trigger(map, 'resize');
    map.setCenter(center);
  });
  return map;
}

export function destroyMap(map) {
  if (typeof window.google !== 'undefined') {
    google.maps.event.clearListeners(map, 'resize');
  }
}

export function geocodeAddressPromise(address) {
  return new Promise((resolve, reject) => {
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({address: address}, function(results, status) {
      if (status == 'OK') {
        var latLong = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        };
        resolve(latLong);
      } else {
        reject(status);
      }
    });
  });
}

function getScriptWithPromise(url) {
  return new Promise((resolve, reject) => {
    $.getScript(url)
      .done(function(data) {
        resolve(data);
      })
      .fail(function(error) {
        reject(error);
      });
  });
}
